import { styled } from '@mui/material/styles';

/**
 * 32px round color sample. `bordered` rings a near-white color so it stays visible on paper,
 * and an icon inside is drawn in a color that contrasts with the fill.
 */
export const CircleSwatch = styled('div', {
  shouldForwardProp: prop => prop !== 'color' && prop !== 'bordered',
})<{ color: string; bordered?: boolean }>(({ theme, color, bordered }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 32,
  height: 32,
  borderRadius: '50%',
  backgroundColor: color,
  border: bordered ? `2px solid ${theme.palette.divider}` : 'none',
  '& > .MuiSvgIcon-root': {
    fontSize: 16,
    opacity: 0.8,
    color: bordered ? theme.palette.text.primary : theme.palette.common.white,
  },
}));
